(() => {
    'use strict';

    howspace.widgets.canvas = {
        initView: widget => {
            howspace.annotation.initView(widget);

            // Blank canvas button.
            widget.find('.blank-canvas-btn').on('click', () => {
                const dataPayload = {
                    canvas_type: 'blank'
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type : 'POST',
                    data : JSON.stringify(dataPayload)
                });
            });
        },
        destroyView: widget => {
            howspace.annotation.destroyView(widget);
        },
        initEdit: widget => {
            howspace.annotation.initEdit(widget);

            // Anonymity radio buttons.
            widget.find('.anonymity-radio').on('change', e => {
                const checkbox = widget.find('.filter-checkbox');
                if (e.target.value === 'anonymous') {
                    howspace.form.disable(checkbox);
                    checkbox.find('input').prop('checked', false);
                } else {
                    howspace.form.enable(checkbox);
                }
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        save: (widget, dataPayload) => {
            if (dataPayload.canvas_type === 'image' && !dataPayload.image_file) {
                dataPayload.canvas_type = 'blank';
            }
            dataPayload.note_categories = [];
            widget.find('.note-categories .note-category').each((_i, category) => {
                const color = howspace.components.colorPicker.getColor(category.querySelector('.note-category-color-picker')).hsl;
                const ratioToWhite = howspace.components.colorPicker.contrastRatio(color, {r:255,g:255,b:255});
                const ratioToBlack = howspace.components.colorPicker.contrastRatio(color, {r:0,g:0,b:0});
                const isDark = ratioToWhite > ratioToBlack;
                dataPayload.note_categories.push({
                    name: category.querySelector('.note-category-name-input').value.trim(),
                    color: color,
                    dark: isDark,
                    enabled: category.querySelector('.note-category-checkbox').checked,
                });
            });
            return dataPayload;
        },
        initFileUploaderModal: (modal, modalOpener) => {
            const widget = $(modalOpener).closest('.widget');

            modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
                const dataPayload = {
                    canvas_type: 'image',
                    image_file: e.detail.uploadedFiles[0].id
                };

                real.ajax.json(howspace.widgets.getApiUrl(widget), {
                    type : 'POST',
                    data : JSON.stringify(dataPayload)
                });

                howspace.components.modal.close(modal);
            });
        },
        updateFilter : (widget) => {
            howspace.annotation.getPins(widget);
        },
        startAnnotating: () => {},
        stopAnnotating: () => {}
    };
})();
